export const styles = {
  root: {
    width: "500px",
  },
  closeButton: {
    position: "absolute",
    top: "2px",
    right: "8px",
  },
  header: {
    padding: "16px 20px",
  },
  actions: {
    padding: "20px",
    justifyContent: "center",
    gap: "14px",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    paddingTop: "16px !important",
    padding: "16px 20px",
    paddingBottom: 0,
  },
};
